import { Coords, SpreadGroundImage } from 'editor/src/store/design/types';

import loadImage from 'editor/src/util/loadImage';

import createSpreadMaskClipPath from 'editor/src/component/EditorArea/Spread/Page/createSpreadMaskClipPath';

const imageCache = new Map<string, Promise<HTMLImageElement | undefined>>();

function loadCachedImage(url: string) {
  const cached = imageCache.get(url);
  if (cached) {
    return cached;
  }

  const promise = loadImage(url, 'anonymous', { executor: 'loadSpreadMaskClipPath' }).catch(() => undefined);
  imageCache.set(url, promise);
  return promise;
}

async function loadSpreadMaskClipPath(
  maskImageData: SpreadGroundImage | undefined,
  spreadWidth: number,
  spreadHeight: number,
  spreadCoords: Coords,
  mm2px: (size: number) => number,
) {
  if (!maskImageData?.url) {
    return undefined;
  }

  const maskImage = await loadCachedImage(maskImageData.url);
  if (!maskImage) {
    return undefined;
  }

  return createSpreadMaskClipPath(maskImageData, maskImage, mm2px(spreadWidth), mm2px(spreadHeight), spreadCoords);
}

export default loadSpreadMaskClipPath;
